<div class="toast-container position-fixed top-0 start-50 translate-middle-x p-3 ">
  <div id="successToast" style="background: #23CB81;" class="toast  border-0 rounded-top-extra rounded-bottom-extra" role="alert" aria-live="assertive" aria-atomic="true" data-bs-delay="4000">
    <div class="toast-body border-0 rounded-top-extra rounded-bottom-extra" >
      <div class="row">
        <div class="col-2 d-flex justify-content-center align-items-center">
          <i class="bi bi-check-circle-fill fs-5 success-colour"></i>
          <!-- <i class="bi bi-check-circle fs-5" style="color: #00de61;"></i> -->
          <!-- <i class="bi bi-check-square fs-1 text-white"></i> -->
        </div>
        <div class="col-auto">
          <h3 class="fw-bold pb-0 mb-0 success-colour">Berjaya</h3>
          <p class="text-white">{{Message}}</p>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="toast-container position-fixed top-0 start-50 translate-middle-x p-3 ">
  <div id="failToast" style="background: #E43D3D;" class="toast border-0 rounded-top-extra rounded-bottom-extra" role="alert" aria-live="assertive" aria-atomic="true" data-bs-delay="4000">
    <div class="toast-body border-0 rounded-top-extra rounded-bottom-extra ">
      <div class="row">
        <div class="col-2 d-flex justify-content-center align-items-center">
          <i class="bi bi-x-circle-fill fs-5 fail-colour"></i>
          <!-- <i class="bi bi-exclamation-triangle fs-1 text-white"></i> -->
        </div>
        <div class="col-auto">
          <h3 class="fw-bold pb-0 mb-0 fail-colour">Gagal</h3>
          <p class="text-white">{{Message}}</p>
        </div>
      </div>
    </div>
  </div>
</div>
